module.exports = __webpack_public_path__ + "static/media/pm_hc_products4.40641c36.png";